/**
 * @generated SignedSource<<1b0aabd4b3a6c60e2c2da8559cb2867f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplacePersonalizedCarouselLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPersonalizationCarousel_viewer">;
  readonly " $fragmentType": "PdpRespMarketplacePersonalizedCarouselLazy_viewer";
};
export type PdpRespMarketplacePersonalizedCarouselLazy_viewer$key = {
  readonly " $data"?: PdpRespMarketplacePersonalizedCarouselLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplacePersonalizedCarouselLazy_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedPersonalizationCarousel_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b5201995e9e1ad156281b91f8f29b704";

export default node;
